export default "__VITE_ASSET__2wJjq5dn__"